/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetOrderPackageRelocationDeliverySchedules(orderPackageID) {
  const response = await $.soap({
    body: {
      GetOrderPackageCustomerOrderDeliverySchedules: {
        $xmlns: 'http://dla.mil/ems/bpm/order_package',
        OrderPackageID: orderPackageID
      }
    },
    blueprintArrays: ['GetOrderPackageCustomerOrderDeliverySchedulesResponse.tuple'],
    blueprint: {
      customerOrderDeliverySchedules: [
        '$..GetOrderPackageCustomerOrderDeliverySchedulesResponse.tuple',
        {
          orderId: '$..OrderID',
          deviceMake: '$..DeviceMake',
          deviceModel: '$..ModelNumber',
          fromBase: '$..FromBase',
          fromOrgUnit: '$..FromOrgUnit',
          fromAddress: {
            id: '$..FromAddressID',
            addressLine1: '$..FromAddress1',
            addressLine2: '$..FromAddress2',
            buildingFloorNumber: '$..FromBuildingFloorNumber',
            floorNumber: '$..FromFloorNumber',
            roomNumber: '$..FromRoomNumber',
            poleNumber: '$..FromPoleNumber',
            suite: '$..FromSuite',
            roomPoleNumber: '$..FromRoomPoleNumber',
            city: '$..FromCity',
            regionId: '$..FromRegionID',
            zip: '$..FromZip',
            regionCode: '$..FromRegionCode',
            regionName: '$..FromRegionName',
            isConus: '$..FromIsConus',
            organization: '$..FromOrgUnit',
            base: '$..FromBase'
          },
          fromAddressId: '$..FromAddressID',
          fromDeliveryPOC: {
            deliveryPOCFirstName: '$..FromDeliveryPOCFirstName',
            deliveryPOCLastName: '$..FromDeliveryPOCLastName',
            deliveryPOCEmail: '$..FromDeliveryPOCEmail',
            deliveryPOCPhone: '$..FromDeliveryPOCPhone'
          },
          fromITPOC: {
            itPOCFirstName: '$..FromITPOCFirstName',
            itPOCLastName: '$..FromITPOCLastName',
            itPOCEmail: '$..FromITPOCEmail',
            itPOCPhone: '$..FromITPOCPhone'
          },
          fromStandardPocId: '$..FromDeliveryPOCID',
          fromItPocId: '$..FromITPOCID',
          toBase: '$..ToBase',
          toOrgUnit: '$..ToOrgUnit',
          toAddress: {
            id: '$..ToAddressID',
            addressLine1: '$..ToAddress1',
            addressLine2: '$..ToAddress2',
            buildingFloorNumber: '$..ToBuildingFloorNumber',
            floorNumber: '$..ToFloorNumber',
            roomNumber: '$..ToRoomNumber',
            poleNumber: '$..ToPoleNumber',
            suite: '$..ToSuite',
            roomPoleNumber: '$..ToRoomPoleNumber',
            city: '$..ToCity',
            regionId: '$..ToRegionID',
            zip: '$..ToZip',
            regionCode: '$..ToRegionCode',
            regionName: '$..ToRegionName',
            isConus: '$..ToIsConus',
            base: '$..ToBase',
            organization: '$..ToOrgUnit'
          },
          toAddressId: '$..ToAddressID',
          toDeliveryPOC: {
            deliveryPOCFirstName: '$..ToDeliveryPOCFirstName',
            deliveryPOCLastName: '$..ToDeliveryPOCLastName',
            deliveryPOCEmail: '$..ToDeliveryPOCEmail',
            deliveryPOCPhone: '$..ToDeliveryPOCPhone'
          },
          toITPOC: {
            itPOCFirstName: '$..ToITPOCFirstName',
            itPOCLastName: '$..ToITPOCLastName',
            itPOCEmail: '$..ToITPOCEmail',
            itPOCPhone: '$..ToITPOCPhone'
          },
          toStandardPocId: '$..ToDeliveryPOCID',
          toItPocId: '$..ToITPOCID'
        }
      ]
    }
  });

  cleanUpResponse(response);

  _.each(response.customerOrderDeliverySchedules, (deliverySchedule) => {
    deliverySchedule.deliveryPOCName = deliverySchedule.deliveryPOCFirstName
      ? `${deliverySchedule.deliveryPOCFirstName} ${deliverySchedule.deliveryPOCLastName}`
      : null;
    deliverySchedule.itPOCName = deliverySchedule.itPOCFirstName
      ? `${deliverySchedule.itPOCFirstName} ${deliverySchedule.itPOCLastName}`
      : null;
  });

  return response.customerOrderDeliverySchedules;
}
